import { sendUserActionPost } from "shared/user-actions/user-actions-action-creators"
import { isRegionCustom } from "shared/region-selection/helperFunctions"

/**
 * Changes the user's current region, through the /change_region/ endpoint.
 * @param  {number} value [SupportedRegion enum value]
 * @param  {string} previousUrl    URL of the previous page to be redirected to after changing region
 */
// based on app/static/frontend/subfeatures/RegionSelectionPage/action-creators.jsx > changeRegion
export const changeRegion = (value: string, previousUrl: string) => {
    const regionEnumItem = DjangIO.app.models.SupportedRegion.by_value(Number(value))
    const newRegionAbbrev =
        isRegionCustom(value) || !regionEnumItem
            ? // either a custom region value or a region that is not yet supported
              value
            : // regular region enum value
              regionEnumItem.abbrev
    sendUserActionPost({
        userActionType: DjangIO.app.useractions.types.UserActionType.change_region,
        description: newRegionAbbrev,
    })

    // change_region logic in app/views.py uses the current_url to decide where to
    // redirect the user, so pass previous url (not a good way to pop the current
    // page before the location.replace for change_region, user would see 2 major segues
    // which is disorienting)
    const overrideUrl = encodeURIComponent(previousUrl)

    // prepare page for redirect - will get a fresh slate
    localStorage.clear()
    sessionStorage.clear()

    // go to /change_region/<region-abbrev>/ to trigger the change_region logic
    // (window.location.replace triggers a page refresh, change_region redirects to proper place)
    window.location.replace(`/change_region/${newRegionAbbrev}/?force_mobile=${false}&override_url=${overrideUrl}`)
}

// based on app/static/frontend/subfeatures/RegionSelectionPage/containers/RegionSelectionPage.jsx > changeRegionOrLinkToProductPage
export const handleApplyRegion = (value: string) => {
    if (!value) return

    changeRegion(value, `${window.location.pathname}${window.location.search}`)
}

export const createRegionsDict = (regionGroups) => {
    return regionGroups.reduce((regionAbbrevDict, regionGroup) => {
        const groupAbbrevDict = regionGroup.regions.reduce(
            (groupDict, region) => ({
                ...groupDict,
                [region.abbrev]: region,
            }),
            {},
        )

        return { ...regionAbbrevDict, ...groupAbbrevDict }
    }, {})
}

export const createCustomRegionsDict = (customRegions) => {
    if (customRegions.data?.length) {
        return customRegions.data.reduce(
            (customRegionDict, customRegion) => ({
                ...customRegionDict,
                [customRegion.value]: customRegion,
            }),
            {},
        )
    }
    return {}
}
